import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { unpack_validation, } from 'webui/Z3KConfigParser/validation/types';
import { MaterialBoolControl, MaterialDropdown } from 'console/shared/components/fields';
import { DHWControlType } from '../../utils/dhw-control-type';
import { removeNulls } from 'utils';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
const strip_name = (name) => name.substr(0, 10);
export const DHWRow = memo(function DHWRow(props) {
    const { settings, validation, onChange } = props;
    const onChangeName = useCallback((value) => onChange({ name: strip_name(value) }), [onChange, strip_name]);
    const onChangeType = useCallback((value) => onChange({ control_type: value }), [onChange]);
    const boiler_control_type_options = useMemo(() => removeNulls([
        { text: 'Отключен', value: DHWControlType.OFF },
        { text: 'Бойлер', value: DHWControlType.BOILER },
        settings.has_adapter_on_slot_1
            ? {
                text: 'Двухконтурный',
                value: DHWControlType.FLOW_DHW,
            }
            : null,
        settings.has_adapter_on_slot_1
            ? {
                text: 'Котёл + бойлер',
                value: DHWControlType.BOILER_PLUS_DHW_BOILER,
            }
            : null,
    ]), [settings.has_adapter_on_slot_1]);
    const type_field = useCallback((input_props) => (_jsx(MaterialDropdown, { options: boiler_control_type_options, ...input_props })), [boiler_control_type_options]);
    return (_jsxs(_Fragment, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", validation_result: unpack_validation(validation, 'name'), validation_warnings_result: null, value: settings.name, onChange: onChangeName, field: TextInputWrapper, help_id: null }), _jsx(Control, { label: "\u0422\u0438\u043F", validation_result: unpack_validation(validation, 'control_type'), validation_warnings_result: null, value: settings.control_type, onChange: onChangeType, field: type_field, help_id: null }), (settings.control_type === DHWControlType.BOILER_PLUS_DHW_BOILER ||
                settings.control_type === DHWControlType.FLOW_DHW) && (_jsx(MaterialBoolControl, { color: "primary", label: "\u0412\u0442\u043E\u0440\u043E\u0439 \u043A\u043E\u043D\u0442\u0443\u0440", value: settings.boiler_second_channel, onChange: (check) => onChange({ boiler_second_channel: check }) }))] }));
});
